<template>
  <div class="mail-info col-md-12 flex mt-4 mail-green">
    <div class="col-md-9 flex align-items-center">
      <span class="flex">
        <span>
          <span>
            <i class="fa fa-check claim-refund-icon-checkmark" /> Customer has been refunded for
          </span>
          <span class="refund-msg">
            ${{ refundTotals.join(', $') }}
          </span>
        </span>
      </span>
    </div>
    <div class="col-md-3 text-right flex justify-content-center align-items-center">
      <router-link class="text-decoration-none" :to="`/jobs/edit/${claim.job.id}`">
        <span class="flex">
          <p class="pr-2 m-t text-dark">See job</p>
          <span class="m-t">
            <i class="fa fa-arrow-right claim-refund-icon-arrow" />
          </span>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    refunds: {
      type: Array,
      default: () => [],
    },
    claim: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    refundTotals() {
      return this.refunds.map(el => el.total);
    },
  },
};
</script>

<style scoped>
.m-t {
  margin-top: 14px;
}

.claim-refund-icon-checkmark {
  font-size: 16px;
  color: #2db300;
  padding-right: 6px;
}
.claim-refund-icon-arrow {
  color: #2db300;
}
.refund-msg {
  font-size: 15px;
  color: #4c5669;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimRefunds.vue